
import clientManagement from "./clientManagementSlice" 

export const clientManagementStoreReducers = {
    clientManagement:clientManagement
};

export const clientManagementStoreBlackList = [
 "clientManagement"
];